(() => {
    'use strict';

    if (window.__mellerStickyATCOptimizedReady) return;
    window.__mellerStickyATCOptimizedReady = true;

    const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    const states = new Set();
    const shellStateMap = new WeakMap();

    let observer = null;
    let fallbackEnabled = false;
    let fallbackRaf = 0;

    const isMobile = () => {
      return !!(mobileQuery && mobileQuery.matches);
    };

    const updatePlaceholderHeight = (state) => {
      if (!state || !state.placeholder || !state.target) return;

      state.placeholder.style.height = `${state.target.offsetHeight}px`;
    };

    const enableSticky = (state) => {
      if (!state || !isMobile()) return;

      updatePlaceholderHeight(state);

      state.target.classList.add('is-sticky-mobile');
      state.placeholder.classList.add('is-active');
      state.isSticky = true;
    };

    const disableSticky = (state) => {
      if (!state) return;

      state.target.classList.remove('is-sticky-mobile');
      state.placeholder.classList.remove('is-active');
      state.placeholder.style.height = '';
      state.isSticky = false;
    };

    const checkState = (state) => {
      if (!state || !state.shell) return;

      if (!isMobile()) {
        disableSticky(state);
        return;
      }

      const rect = state.shell.getBoundingClientRect();

      if (rect.bottom <= 0) {
        enableSticky(state);
      } else {
        disableSticky(state);
      }
    };

    const requestFallbackCheck = () => {
      if (fallbackRaf) return;

      fallbackRaf = window.requestAnimationFrame(() => {
        fallbackRaf = 0;

        states.forEach(checkState);
      });
    };

    const enableFallbackListeners = () => {
      if (fallbackEnabled) return;

      fallbackEnabled = true;

      window.addEventListener('scroll', requestFallbackCheck, { passive: true });
      window.addEventListener('resize', requestFallbackCheck, { passive: true });
    };

    const ensureObserver = () => {
      if (observer || !('IntersectionObserver' in window)) return observer;

      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const state = shellStateMap.get(entry.target);

          if (!state) return;

          if (!isMobile()) {
            disableSticky(state);
            return;
          }

          if (!entry.isIntersecting && entry.boundingClientRect.bottom <= 0) {
            enableSticky(state);
          } else {
            disableSticky(state);
          }
        });
      });

      return observer;
    };

    const initStickyATC = (scope = document) => {
      const root = scope && scope.querySelectorAll ? scope : document;
      const blocks = root.querySelectorAll('[data-meller-buy-buttons]');

      blocks.forEach((block) => {
        if (block.dataset.mellerStickyInit === 'true') return;

        const shell = block.querySelector('[data-meller-sticky-shell]');
        const target = block.querySelector('[data-meller-sticky-target]');
        const placeholder = block.querySelector('[data-meller-sticky-placeholder]');

        if (!shell || !target || !placeholder) return;

        const state = {
          block,
          shell,
          target,
          placeholder,
          isSticky: false,
          resizeObserver: null
        };

        block.dataset.mellerStickyInit = 'true';
        states.add(state);
        shellStateMap.set(shell, state);

        if ('ResizeObserver' in window) {
          state.resizeObserver = new ResizeObserver(() => {
            if (state.isSticky) {
              updatePlaceholderHeight(state);
            }
          });

          state.resizeObserver.observe(target);
        }

        const io = ensureObserver();

        if (io) {
          io.observe(shell);
          checkState(state);
        } else {
          enableFallbackListeners();
          requestFallbackCheck();
        }
      });
    };

    const handleViewportChange = () => {
      states.forEach(checkState);
    };

    if (mobileQuery) {
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleViewportChange);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(handleViewportChange);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initStickyATC(document), { once: true });
    } else {
      initStickyATC(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initStickyATC(event.target || document);
    });
  })();

